"use client";
import React from "react";
import { useSearchParams } from "next/navigation";
import {
  ParentPagination,
  PaginationGap,
  PaginationList,
  PaginationNext,
  PaginationPage,
  PaginationPrevious,
} from "../atoms/pagination";

export function Pagination({ pages }: { pages: number }) {
  const searchParams = useSearchParams();
  const current = searchParams.get("page");
  const total = Array.from({ length: pages }, (_, index) => index + 1);
  const top = total.slice(0, 3);
  const bottom = total.slice(3).slice(-3);
  const buildHref = (page: number) => {
    const params = new URLSearchParams(searchParams.toString());
    params.set("page", `${page}`);
    return `?${params.toString()}`;
  };

  return (
    <>
      <nav
        className="flex items-center justify-end pt-8 pb-2 max-sm:-mx-[5px]"
        aria-label="Pagination">
        <div className="w-full lg:w-auto lg:mr-2">
          <ParentPagination>
            {!current || current == "1" ? (
              <PaginationPrevious />
            ) : (
              <PaginationPrevious href={buildHref(Number(current) - 1)} />
            )}
            <PaginationList>
              {top.map((item) => {
                return (
                  <PaginationPage
                    key={item}
                    href={buildHref(item)}
                    current={
                      (!current && String(item) == "1") ||
                      String(item) == current
                    }>{`${item}`}</PaginationPage>
                );
              })}
              {pages >= 4 ? (
                <>
                  <PaginationGap />
                  {bottom.map((item) => {
                    return (
                      <PaginationPage
                        key={item}
                        href={buildHref(item)}
                        current={
                          String(item) == current
                        }>{`${item}`}</PaginationPage>
                    );
                  })}
                </>
              ) : (
                <></>
              )}
            </PaginationList>
            {pages == 1 || Number(current) == pages ? (
              <PaginationNext />
            ) : (
              <PaginationNext
                href={buildHref(!current ? 2 : Number(current) + 1)}
              />
            )}
          </ParentPagination>
        </div>
      </nav>
    </>
  );
}
